import { InputsService_collCalcInputServiceGetQueryCcInput } from '@festina/collcalc-general-types/collcalc/hooks/InputsService_collCalcInputServiceGetQueryCcInput'

export const useFetchCollCalcInput =
  InputsService_collCalcInputServiceGetQueryCcInput.useSuspenseQuery
